export enum ProductUnitPackageMaterialField {
    Amount = 1,
    IsReusable = 2,
    ProductUnit = 3,
    MaterialType = 4,
    SortOrder = 5
}

(ProductUnitPackageMaterialField as any).__typeName = 'ProductUnitPackageMaterialField';
